/**
 * @file index.tsx
 *
 * @fileoverview Renders a call to action row.
 */

import React from 'react';
import { CtaSimpleBackgroundParagraph } from '~/jobiqo/types/types';
import { RowButtons } from '../RowButtons';
import { Text } from '~/vcl/atoms/13-text/03-text';
import { Box } from '~/vcl/atoms/07-box';
import { Grid } from '~/vcl/atoms/06-layout/04-grid';
import { Cell } from '~/vcl/atoms/06-layout/04-grid/01-cell';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { Main } from '~/vcl/atoms/06-layout/09-main';

interface CTASimpleBackgroundProps {
  row: CtaSimpleBackgroundParagraph;
  maxContainerSize?: 'small' | 'medium' | 'large' | 'xLarge';
}
export const CTASimpleBackground = ({
  row,
  maxContainerSize,
}: CTASimpleBackgroundProps) => {
  return (
    <Box
      boxShadow="none"
      borderRadius="0px"
      paddingTop={row.spacing ?? 12}
      paddingBottom={row.spacing ?? 12}
      paddingLeft={[6, 12]}
      paddingRight={[6, 12]}
      marginTop={0}
      backgroundColorOverride={
        row.background ? `var(--color-${row.background})` : `var(--color-gray9)`
      }
    >
      <Main {...(maxContainerSize ? { size: maxContainerSize } : null)}>
        <Grid alignItems="center" columns={[1, 3]}>
          <Cell gridColumn={'span 2'} gridRow={1}>
            <Text tag="h2" color="white" fontSize={[6, 8]} lineHeight={[6, 7]}>
              {row.title}
            </Text>
            <Spacing size="medium" />
            <Text
              fontSize={[5, 7]}
              lineHeight={[5, 6]}
              fontWeight="bold"
              color="gray4"
            >
              {row.subtitle}
            </Text>
          </Cell>
          <Cell>
            <RowButtons
              button1={row.button1}
              button2={row.button2}
              buttonStyle={row.color as any}
              justifyContent="flex-start"
            />
          </Cell>
        </Grid>
      </Main>
    </Box>
  );
};
export default CTASimpleBackground;
